import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";
import { IApiResponse } from "../../Orchestrator/Types/Index";

export async function deleteBookedOffer(bookingId: string, offerId: string): Promise<IApiResponse<any>> {
    const endpoints = await getEndpoints();
    const endpoint = endpoints.deleteBookOfferToBookingAPI(bookingId, offerId);
    return await apiRequest<any>(endpoint, "DELETE");
} 